<template>
  <div class="question-card mb-6 border-l-4 border-primary-300 hover:border-primary-500">
    <span class="tag" :class="getTagClass(question.category)">{{ question.category }}</span>
    <h3 class="text-xl font-bold mt-2 mb-3">
      <router-link :to="{ name: 'question-detail', params: { id: question.id } }" class="hover:text-primary-600">
        {{ question.title }}
      </router-link>
    </h3>
    <div class="flex justify-between text-sm text-gray-500 mb-4">
      <span class="flex items-center">
        <svg class="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
          <path d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"></path>
        </svg>
        {{ question.askedBy }}
      </span>
      <span class="flex items-center">
        <svg class="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clip-rule="evenodd"></path>
        </svg>
        {{ question.askedAt }}
      </span>
    </div>
    <p class="text-gray-600 mb-4">{{ truncateContent(question.content) }}</p>
    <div class="text-right">
      <router-link 
        :to="{ name: 'question-detail', params: { id: question.id } }" 
        class="btn btn-outline"
      >
        查看详情
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuestionCard',
  props: {
    question: {
      type: Object,
      required: true
    }
  },
  methods: {
    // 截断内容显示
    truncateContent(content) {
      if (content.length <= 100) return content;
      return content.substring(0, 100) + '...';
    },
    getTagClass(category) {
      // 根据分类名称返回不同的样式类
      const categoryMap = {
        '自然科学': 'tag-primary',
        '历史': 'tag-secondary',
        '生活': 'tag-accent',
        '天文': 'tag-fun',
        '动物': 'tag-primary',
        '植物': 'tag-accent',
        '技术': 'tag-secondary',
        '艺术': 'tag-fun',
        '数学': 'tag-primary',
        '语言': 'tag-secondary'
      };
      
      return categoryMap[category] || 'tag-primary';
    }
  }
}
</script>

<style scoped>
/* 样式已经在App.vue全局样式中定义 */
</style> 